import "altcha/i18n";

export interface AltchaWidgetElement extends HTMLElement {
  reset(): void;
}

declare const $altcha: {
  algorithms: Map<string, () => Worker>;
};

let altchaInitialized = false;

export function setupAltcha(): void {
  if (altchaInitialized) return;
  altchaInitialized = true;

  $altcha.algorithms.set(
    "ARGON2ID",
    () => new Worker(new URL("altcha/workers/argon2id", import.meta.url)),
  );
}

export function makeAltchaBoxClickable(widget: HTMLElement): void {
  widget.addEventListener("click", (e) => {
    const checkbox = widget.querySelector(".altcha-checkbox") as HTMLElement | null;
    const input = checkbox?.querySelector("input") as HTMLInputElement | null;
    if (input && checkbox && !checkbox.contains(e.target as Node)) {
      input.click();
    }
  });
  widget.style.cursor = "pointer";
}

export function waitForAltcha(
  wrapper: HTMLDivElement,
  widget: AltchaWidgetElement,
): Promise<string> {
  return new Promise((resolve, reject) => {
    widget.reset();
    wrapper.classList.remove("d-none");

    function onStateChange(e: Event) {
      const state = (e as CustomEvent).detail?.state;
      if (state === "verified") {
        widget.removeEventListener("statechange", onStateChange);
        const payload = (e as CustomEvent).detail?.payload as string;
        wrapper.classList.add("d-none");
        resolve(payload);
      } else if (state === "error") {
        widget.removeEventListener("statechange", onStateChange);
        wrapper.classList.add("d-none");
        reject(new Error("ALTCHA verification failed"));
      }
    }

    widget.addEventListener("statechange", onStateChange);
  });
}
